'use client';

import { notFound, useParams } from 'next/navigation';
import { Image } from 'react-datocms';
import { Activity } from '~/components/Activity';
import { Breadcrumbs } from '~/components/Breadcrumbs';
import { Card } from '~/components/Card';
import { Divider } from '~/components/Divider';
import { useJourneyGuide } from '~/contexts/JourneyGuideContext';
import TimelineTransformer, {
  type StayTimelineItem,
  type StopTimelineItem
} from '~/transformers/Dato/TimelineTransformer';

export default function ActivityDetail() {
  const params = useParams<{
    activityId: string;
    placeId: string;
    tripId: string;
  }>();

  const tripId = params?.tripId;
  const placeId = params?.placeId;
  const activityId = params?.activityId;

  const [journeyGuide] = useJourneyGuide();

  const { timelineItems: items } = new TimelineTransformer(journeyGuide.itinerary?.items ?? []).transform();

  const place = items.find((item) => item.id === placeId) as StayTimelineItem | StopTimelineItem;
  if (!place) {
    return notFound();
  }

  const activity = place.activities?.find((activity) => activity.id === activityId);

  const { id, images } = activity ?? {};

  return (
    <div className="mb-48px">
      <div className="px-4 pt-4 bg-primary-100">
        <Breadcrumbs
          items={[
            {
              href: `/journey-guide/${tripId}#${id}`,
              label: 'Journey Guide'
            },
            {
              href: `/journey-guide/${tripId}/${placeId}#${id}`,
              label: place.title
            },
            {
              label: activity?.activityTitle || '',
              isCurrent: true,
              href: '#'
            }
          ]}
        />
      </div>
      <Divider variant="horizontal" />
      {images?.[0]?.responsiveImage && (
        <>
          {/* eslint-disable-next-line jsx-a11y/alt-text */}
          <Image data={images[0].responsiveImage} />
        </>
      )}
      <Card spaceHorizontal="--by-space-400" spaceVertical="--by-space-300">
        <Activity activity={activity} isDetailed />
      </Card>
    </div>
  );
}
